import React, { useEffect, useState } from 'react';
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import NoDataAvailable from '../NoDataAvailable';
import { Spinner } from 'react-bootstrap';
import ChartTitle from '../../../../../elements/ChartTitle';

const GRAPH_TITLE = 'Defect Distribution By Priority And Engineer';
const totalColor = '#17a589';

const DefectsLoggedPerUser = ({
  data,
  dateFilters,
  loading,
  isJiraIntegrated,
  getPriorityColor,
  handleRefresh,
  isFetching,
}) => {
  const [chartData, setChartData] = useState([]);
  const [priorities, setPriorities] = useState([]);

  useEffect(() => {
    if (!data.length) {
      setChartData([]);
      setPriorities([]);
      return;
    }

    const prioritySet = new Set();
    const issueCount = {};

    data.forEach(({ reporter = 'Others', priority = 'Unknown' }) => {
      prioritySet.add(priority);
      issueCount[reporter] ??= { user: reporter, Total: 0 };
      issueCount[reporter][priority] =
        (issueCount[reporter][priority] || 0) + 1;
      issueCount[reporter].Total += 1;
    });

    setPriorities([...prioritySet]);
    setChartData(Object.values(issueCount));
  }, [data]);

  const priorityColors = priorities.reduce((colors, priority) => {
    colors[priority] = getPriorityColor(priority);
    return colors;
  }, {});

  const totalCount = chartData.reduce((total, { Total }) => total + Total, 0);

  return (
    <div className="chart-div">
      <ChartTitle
        title={GRAPH_TITLE}
        showWarning={!isJiraIntegrated}
        dateFilters={dateFilters}
        onRefresh={handleRefresh}
        isFetching={isFetching}
        showRefreshButton={!loading && isJiraIntegrated}
      />
      {loading ? (
        <Spinner className="mt-5" />
      ) : chartData.length === 0 ? (
        <NoDataAvailable />
      ) : (
        <>
          <p className="text-muted mb-0">
            Total Defects Logged: {totalCount}
          </p>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              width={900}
              height={500}
              barSize={25}
              data={chartData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="user"
                label={{
                  value: 'Engineers',
                  position: 'insideBottom',
                  offset: -10,
                }}
                tick={{ fontSize: 12 }}
              />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Legend wrapperStyle={{ padding: 10 }} />
              <Bar dataKey="Total" fill={totalColor} name="Total Defects" />
              {priorities.map((priority) => (
                <Bar
                  key={priority}
                  dataKey={priority}
                  stackId="a"
                  fill={priorityColors[priority]}
                  name={priority}
                />
              ))}
            </BarChart>
          </ResponsiveContainer>
        </>
      )}
    </div>
  );
};

export default DefectsLoggedPerUser;
